export default "__VITE_ASSET__D9AW$O5G__"